export { default as StaticImage } from './StaticImage';
export {
  default as StaticAssetProvider,
  useStaticAssetPath,
} from './StaticAssetProvider';
export { default as StaticLink } from './StaticLink';
export { default as StaticVideo } from './StaticVideo';
